import { render, staticRenderFns } from "./PRHome.vue?vue&type=template&id=6bc68905&"
import script from "./PRHome.vue?vue&type=script&lang=js&"
export * from "./PRHome.vue?vue&type=script&lang=js&"
import style0 from "./PRHome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports